module.exports = __webpack_public_path__ + "static/media/file.c828a7b4.svg";